import { PERCENTAGE_OF_LIST_TO_TRAVERSE_BEFORE_TRIGGERING_NEXT_PAGE } from './constants';
/**
 * This is a Fluent UI `DetailsList` `onRenderRow` function that will
 * automatically call the next page when the user is most of the way through
 * the list. This creates the illusion of infinite scrolling, without the user
 * having to click a "Load More" button.
 */
export const onRenderRowDetailsListWithInfiniteScroll = (
/**
 * The list of items to render.
 */
itemList, 
/**
 * Whether or not there is a next page to load.
 */
hasNextPage, 
/**
 * Whether or not the list is currently loading.
 */
isLoading, 
/**
 * The function to call when the next page should be loaded.
 */
fetchNextPage) => (
/**
 * Pass the props directly from `onRenderRow` to this function.
 */
props, 
/**
 * The function to call when the row should be rendered.
 */
defaultRender) => {
    const returnValue = (defaultRender === null || defaultRender === void 0 ? void 0 : defaultRender(props)) || null;
    // Bail out if this is a tombstone loader or something is broken
    if (!props || !itemList || !hasNextPage || isLoading) {
        return returnValue;
    }
    /** This row's index in the list */
    const index = props.itemIndex || props.flatIndexOffset || 0;
    /** What percentage of the overall list the current row is */
    const position = index / itemList.length;
    // If paging is idle and the current row is beyond the first 40% of the list, load more items.
    // Deliberately ordered to minimize calculations
    if (position > PERCENTAGE_OF_LIST_TO_TRAVERSE_BEFORE_TRIGGERING_NEXT_PAGE) {
        fetchNextPage === null || fetchNextPage === void 0 ? void 0 : fetchNextPage();
    }
    return returnValue;
};
